import { SUPPORTED_DATA_SOURCES } from "../constants/supportedDataSources"

export function isValidDataSource(
  source: string
): source is typeof SUPPORTED_DATA_SOURCES[number] {
  return (SUPPORTED_DATA_SOURCES as unknown as string[]).includes(source)
}
